import React from 'react'
import { Box } from '@usap/uicomponents'
import { Title } from '../../meta'
import QuestionAnswerBox from './QuestionAnswerBox'
import { QuestionAnswerBoxContainer, staticStyle, verticalStyle } from './style/QuestionAnswer.css'

export default function QuestionAnswer({
  title,
  questionAnswer,
  Link,
  formatBrandInText,
  isBot,
}) {
  return (
    <Box
      id="QuestionAndAnswer"
      width="1248px"
      margin={staticStyle.box1Marg}
      pad={staticStyle.box1Pad}
    >
      <Box margin={verticalStyle}>
        <Title type="h2" size="20px" label={title} />
      </Box>
      <QuestionAnswerBoxContainer>
        {
          questionAnswer.map(record => (
            <QuestionAnswerBox
              key={record.id}
              data={record}
              Link={Link}
              isBot={isBot}
              formatBrandInText={formatBrandInText}
            />
          ))
        }
      </QuestionAnswerBoxContainer>
    </Box>
  )
}
